export default function formatPrice(value) {
    return ((+value) || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
}